import type { Mentor, MentorAddress, MentorBattle } from '@mezha/api'
import { baseApi } from '../baseApi'

type Command = { id: string; op: 'lesson' | 'trial' | 'learn' | 'reset'; expected_version: number; skill_id?: string; tier?: number }
export const mentorsApi = baseApi.injectEndpoints({
  endpoints: b => ({
    mentors: b.query<MentorAddress[], void>({ query: () => ({ get: '/api/v1/mentors' }), providesTags: ['Skills', 'World'] }),
    mentor: b.query<Mentor, string>({ query: id => ({ get: `/api/v1/mentors/${encodeURIComponent(id)}` }), providesTags: ['Skills', 'Hero', 'World'] }),
    train: b.mutation<Mentor | MentorBattle, Command>({
      query: ({ id, op, ...body }) => ({ command: `/api/v1/mentors/${encodeURIComponent(id)}/${op}`, body }),
      invalidatesTags: ['Skills', 'Hero', 'ActiveBattle'],
    }),
  }),
})
export const { useMentorsQuery, useMentorQuery, useTrainMutation } = mentorsApi
